export const DisplayTypes = {
  Default: 0,
  FullWidth: 1,
  Float: 2,
  Flex: 3,
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/panel/types.ts